/**
 * @generated SignedSource<<628149cb177ee961dea39bca701c9749>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type exportsPage_Query$variables = Record<PropertyKey, never>;
export type exportsPage_Query$data = {
  readonly exports: ReadonlyArray<{
    readonly byteSize: number | null | undefined;
    readonly createdAt: any;
    readonly downloadPath: string | null | undefined;
    readonly errorMessage: string | null | undefined;
    readonly filename: string;
    readonly finishedAt: any | null | undefined;
    readonly id: string;
    readonly kind: string;
    readonly kindLabel: string;
    readonly label: string | null | undefined;
    readonly status: string;
    readonly summary: string | null | undefined;
  }>;
};
export type exportsPage_Query = {
  response: exportsPage_Query$data;
  variables: exportsPage_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "Export",
    "kind": "LinkedField",
    "name": "exports",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "kind",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "kindLabel",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "label",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "status",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "summary",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "byteSize",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "errorMessage",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "createdAt",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "finishedAt",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "filename",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "downloadPath",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "exportsPage_Query",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "exportsPage_Query",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "f039efb6cb97fa3334049010cae758f9",
    "id": null,
    "metadata": {},
    "name": "exportsPage_Query",
    "operationKind": "query",
    "text": "query exportsPage_Query {\n  exports {\n    id\n    kind\n    kindLabel\n    label\n    status\n    summary\n    byteSize\n    errorMessage\n    createdAt\n    finishedAt\n    filename\n    downloadPath\n  }\n}\n"
  }
};
})();

(node as any).hash = "107d417172922e38dcfecefbe2182d78";

export default node;
